import React, { createContext, useContext, useEffect, useState } from "react";
import { t as translations } from "@/i18n";

export const PHONE = "+966532637224";
export const PHONE_DISPLAY = "+966 53 263 7224";
export const EMAIL = "majidkhans494@gmail.com";
export const WA_MSG_EN = "Hello, I would like to request a quotation for tyres.";
export const WA_MSG_AR = "مرحباً، أرغب في طلب عرض سعر للإطارات.";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const waLink = (msg) => `https://wa.me/966532637224?text=${encodeURIComponent(msg)}`;
export const telLink = `tel:${PHONE}`;
export const mailLink = `mailto:${EMAIL}`;

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");
  const tr = translations[lang];

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.body.setAttribute("dir", tr.dir);
    document.documentElement.setAttribute("lang", lang);
  }, [lang, tr.dir]);

  const toggleLang = () => setLang((p) => (p === "en" ? "ar" : "en"));

  return (
    <AppContext.Provider value={{ lang, setLang, toggleLang, tr }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
